module.exports = __webpack_public_path__ + "static/cercazone_sudovest1-9d666caa774c264a2535b8532d33f60e.jpg";